import { Flex } from 'antd';
import { useFetchMatterRequestsById } from '../../../hooks/useFetchMatterRequestById';
import { MailMetadata } from '../../../interface/mailMetadata';
import ManageMatterRequest from '../../matterRequests/manageMatterRequest';
import { Spin } from '../../Ant';
import MatterRequestCard from '../../conflictSearch/matterRequestCard';

interface IMatterRequestMailProperties {
  mailSubject: string;
  mailMetadata: MailMetadata | null;
  onMatterRequestCreated?: () => void;
}
const MatterRequestMail = ({
  mailSubject,
  mailMetadata,
  onMatterRequestCreated,
}: IMatterRequestMailProperties) => {
  const { data: matterRequest, isLoading } = useFetchMatterRequestsById({
    id: mailMetadata?.matterRequestId ?? '',
    relations: [
      'ownerUser',
      'responsibleUser',
      'matterRequestType',
      'parties',
      'parties.company',
      'parties.privatePerson',
    ],
    fields: [
      'status',
      'createdOn',
      'checkedOnDate',
      'subject',
      'language',
      'currency',
      'description',
      'hasImportantNotes',
      'hasNotes',
      'matterRequestTypeId',
    ],
  });

  return (
    <>
      {isLoading && <Spin fullscreen />}
      {!mailMetadata?.matterRequestId ? (
        <ManageMatterRequest
          showHeader={false}
          isFromMailOrAppointment
          mailSubject={mailSubject}
          onMatterRequestCreated={onMatterRequestCreated}
        />
      ) : (
        matterRequest && (
          <Flex vertical gap={10} className="h-full pb-gutter overflow-y-auto scroll-page-gutter">
            <MatterRequestCard matterRequest={matterRequest} />
          </Flex>
        )
      )}
    </>
  );
};

export default MatterRequestMail;
